module.exports = __webpack_public_path__ + "static/media/workPvcCeilings20.2440cd32.jpg";